module.exports = __webpack_public_path__ + "img/main_bg.e2de0cd0.png";